/**
 * Apollo Client plugin for Vue
 *
 * This plugin integrates Apollo Client with Vue's composition API,
 * making GraphQL queries available throughout the application.
 */

import { DefaultApolloClient } from "@vue/apollo-composable";
import { apolloClient } from "@/graphql/client";
import type { App } from "vue";

export function installApollo(app: App): void {
  // Provide Apollo Client to all components
  app.provide(DefaultApolloClient, apolloClient);
}
